import { useState } from 'react';
import { useDesign } from '../../context/DesignContext';
import type { CardText } from '@flashcard/shared';

const DEFAULT_COLORS = ['#ffffff', '#0a0a0f', '#7c3aed', '#2563eb', '#16a34a', '#dc2626', '#f59e0b'];

export function EditorForm() {
  const { texts, addText, updateText, removeText, backgroundColor, setBackgroundColor, setLogo } = useDesign();
  const [newText, setNewText] = useState('Name');

  const addField = () => {
    addText({
      id: crypto.randomUUID(),
      content: newText,
      x: 42.5,
      y: 20,
      fontSize: 16,
      color: '#0a0a0f',
      align: 'center',
    });
    setNewText('');
  };

  const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setLogo(reader.result as string, { x: 8, y: 8, width: 20, height: 10 });
    };
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <div className="form-group">
        <label>Hintergrundfarbe</label>
        <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
          {DEFAULT_COLORS.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setBackgroundColor(c)}
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: c,
                border: backgroundColor === c ? '2px solid var(--accent)' : '1px solid var(--border)',
                cursor: 'pointer',
              }}
            />
          ))}
          <input
            type="color"
            value={backgroundColor}
            onChange={(e) => setBackgroundColor(e.target.value)}
            style={{ width: 36, height: 28, padding: 0, border: '1px solid var(--border)' }}
          />
        </div>
      </div>

      <div className="form-group">
        <label>Textfelder</label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <input value={newText} onChange={(e) => setNewText(e.target.value)} placeholder="Text…" />
          <button type="button" className="btn btn-secondary" onClick={addField}>
            + Hinzufügen
          </button>
        </div>
      </div>

      {texts.map((t: CardText) => (
        <div
          key={t.id}
          className="card"
          style={{ padding: '0.75rem', marginBottom: '0.75rem' }}
        >
          <input
            value={t.content}
            onChange={(e) => updateText(t.id, { content: e.target.value })}
            style={{ width: '100%', marginBottom: '0.5rem' }}
          />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', fontSize: '0.8rem' }}>
            <label className="text-muted">
              X (mm)
              <input
                type="number"
                value={t.x}
                onChange={(e) => updateText(t.id, { x: Number(e.target.value) })}
              />
            </label>
            <label className="text-muted">
              Y (mm)
              <input
                type="number"
                value={t.y}
                onChange={(e) => updateText(t.id, { y: Number(e.target.value) })}
              />
            </label>
            <label className="text-muted">
              Größe
              <input
                type="number"
                value={t.fontSize}
                onChange={(e) => updateText(t.id, { fontSize: Number(e.target.value) })}
              />
            </label>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem', alignItems: 'center' }}>
            <label className="text-muted" style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.8rem' }}>
              Farbe
              <input
                type="color"
                value={t.color}
                onChange={(e) => updateText(t.id, { color: e.target.value })}
                style={{ width: 30, height: 24, padding: 0 }}
              />
            </label>
            <label className="text-muted" style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.8rem' }}>
              Fett
              <input
                type="checkbox"
                checked={!!t.bold}
                onChange={(e) => updateText(t.id, { bold: e.target.checked })}
              />
            </label>
            <button type="button" className="btn btn-secondary" style={{ marginLeft: 'auto' }} onClick={() => removeText(t.id)}>
              ✕
            </button>
          </div>
        </div>
      ))}

      <div className="form-group">
        <label>Logo</label>
        <input type="file" accept="image/*" onChange={handleLogoUpload} />
      </div>
    </div>
  );
}
